import { Link } from '@tanstack/react-router'
import { RiLogoutBoxLine } from '@remixicon/react'
import { useSession, signOut } from '@/lib/auth'
import { Button } from '@/components/ui/button'

function AdagioLogo() {
	return (
		<Link to="/" className="group flex items-center gap-3">
			<div className="relative flex size-9 items-center justify-center">
				{/* Outer ring with gradient */}
				<div className="absolute inset-0 rounded-full bg-gradient-to-br from-primary/30 via-primary/10 to-transparent transition-all duration-300 group-hover:from-primary/40 group-hover:via-primary/20" />
				{/* Inner circle */}
				<div className="absolute inset-1 rounded-full bg-background" />
				{/* Musical note symbol */}
				<svg
					viewBox="0 0 24 24"
					className="relative z-10 size-5 fill-primary"
					aria-hidden="true"
				>
					<path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z" />
				</svg>
			</div>
			<div className="flex flex-col">
				<span className="font-serif text-lg font-semibold tracking-tight text-foreground">
					Adagio
				</span>
				<span className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground/60">
					Music Bot
				</span>
			</div>
		</Link>
	)
}

export function TopBar() {
	const { data: session } = useSession()
	const user = session?.user

	const handleLogout = async () => {
		await signOut()
	}

	return (
		<header className="sticky top-0 z-40 border-b border-border/50 bg-background/80 backdrop-blur-md">
			<div className="mx-auto flex h-14 max-w-5xl items-center">
				<AdagioLogo />

				{/* Right: User controls */}
				<div className="ml-auto flex items-center gap-1">
					<div className="flex items-center gap-2.5 rounded-sm px-2 py-1.5 transition-colors hover:bg-muted/50">
						{user?.image && (
							<img
								src={user.image}
								alt={user.name || 'User'}
								className="size-6 rounded-full ring-1 ring-border/60"
							/>
						)}
						<span className="hidden text-xs text-muted-foreground sm:inline">
							{user?.name}
						</span>
					</div>
					<div className="mx-1 h-4 w-px bg-border/30 hidden sm:block" />
					<Button
						variant="ghost"
						size="icon-sm"
						onClick={handleLogout}
						className="text-muted-foreground/50 hover:text-foreground"
					>
						<RiLogoutBoxLine className="size-3.5" />
					</Button>
				</div>
			</div>
		</header>
	)
}
